import {useEffect, useState} from 'react';
import DataTable from 'react-data-table-component';
import {useDispatch} from 'react-redux';
import {getXmlReports} from "../../helper/Api";
import { Chip } from '@mui/material';
import { extractDocumentServePath, openSecureDocumentOrToast } from '../../helper/secureDocuments';



export function XmlReportList({setLoading}) {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [schemeList, setSchemeList] = useState([])
    const dispatch = useDispatch();

    const fetch_list = async () => {
        setLoading(true);
        const schemeResponse = await getXmlReports();
        if (schemeResponse.data.status) {
            setLoading(false);
            setSchemeList(schemeResponse.data.result);
        }
    }
    useEffect(() => {
        fetch_list()
    }, [dispatch])
    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };
    const hasProxyRef = (value) => Boolean(extractDocumentServePath(value));

    const openXmlFile = (row, kind) => {
        const isAck = kind === 'ack';
        const stored = isAck ? row?.ack_url : row?.file_url;
        const filename = (isAck ? row?.ack_filename : row?.filename) || (isAck ? 'ack.xml' : 'file.xml');
        // Live xml_reporting still returns an S3 key in file_url (not documents/serve)
        // and ack_url "0" when there is no pull id. Open the resource from the BE map.
        const ref = hasProxyRef(stored)
            ? stored
            : isAck
                ? (row?.ack_id ? `documents/serve/xml_pull/${row.ack_id}/ack_url` : '')
                : (row?.id ? `documents/serve/xml_reporting/${row.id}` : '');
        if (!ref) return;
        openSecureDocumentOrToast(ref, {
            download: true,
            fallbackFilename: filename,
        });
    };

    const fileLinkStyle = {
        margin: 0,
        padding: 0,
        border: 'none',
        background: 'none',
        color: '#1d4ed8',
        fontWeight: 700,
        cursor: 'pointer',
        textAlign: 'left',
    };

    const columns = [
        {
            name: 'Scheme Name',
            selector: (row) => row.name,
            sortable: true,
            width: "200px",
            wrap: true,
            right: true
        },
        {
            name: 'Scheme Code',
            selector: (row) => row.code,
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'File Name',
            cell: (row) => row.filename ? (
                <button
                    type="button"
                    style={fileLinkStyle}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        openXmlFile(row, 'file');
                    }}
                >
                    {row.filename}
                </button>
            ) : '-',
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Ack File Name',
            cell: (row) => (hasProxyRef(row.ack_url) || row.ack_id) && row.ack_filename ? (
                <button
                    type="button"
                    style={fileLinkStyle}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        openXmlFile(row, 'ack');
                    }}
                >
                    {row.ack_filename}
                </button>
            ) : (row.ack_filename || '-'),
            sortable: true,
            width: "250px",
            wrap: true,
        },
        {
            name: 'Report Date',
            selector: (row) => row.uploaded_at,
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Ack Date',
            selector: (row) => row.pulled_at,
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Status',
            selector: (row) => row.response_status === "S" ? (
                <Chip label="Success" color="success" size="small" />
            ) : (
                <Chip label="Found Error" color="error" size="small" />
            ),
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Errors',
            selector: (row) => '',
            sortable: true,
            width: "150px",
            wrap: true,
        },
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    return (
        <>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                columns={columns}
                data={schemeList}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationTotalRows={schemeList.length}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </>

    );
}
